module.exports = __webpack_public_path__ + "img/zs_icon.2c6ace24.png";